import Head from 'next/head'
import Script from 'next/script'
import Image from 'next/image'
import { s3Static } from '../../../utils/constants'
import { getArticleDateTime, reviewedIso } from '../../../utils/article-date-time'
import { BlogsList } from '../../../components/blogs/BlogList'
import { blogsMaster } from '../../../utils/sg-blogs-data'
import { getRequestJSON } from '../../../api/index/location-api'
import Link from 'next/link'
import { AirconServiceCostCalculator } from '../../../components/index/service-category/aircon-service/AirconServiceCostCalculator'
import { AnimatePresence } from 'framer-motion'
import { AirconScope } from '@/index/service-category/aircon-service/AirconScope'
import { airconCostCalculation } from 'js/aircon-cost'
import { RequestProvider } from 'context/RequestContext'
import AirconRequestSection from '@/index/service-category/aircon-service/AirconRequestSection'
import { useState } from 'react'
import AirconPricing from '@/index/service-category/aircon-service/AirconPricing'
import { AirconGeneralServiceProcess } from '@/index/service-category/aircon-service/AirconGeneralServiceProcess'
import ServiceWarranty from '@/index/service-category/aircon-service/ServiceWarranty'
import { buildAirconServiceGraph } from 'utils/aircon-page-schema'


// When this page's content last actually changed. Bump it by hand when you
// edit the copy - not for layout/UX changes. Feeds dateModified and
// article:modified_time (see reviewedIso in utils/article-date-time).
const CONTENT_REVIEWED = '2026-09-22'

export async function getStaticProps() {
    const countryCd = "sg"
    const countryName = "Singapore"
    
    const allRequestCategorySettings = await getRequestJSON(countryName)

    const requestCategorySettings = allRequestCategorySettings.filter(category => category.requestType === "Aircon Services")
    
    const lat = 1.3521
    const lng = 103.8198

    const { month, year } = getArticleDateTime()
    const modifiedDate = reviewedIso(CONTENT_REVIEWED)
    const airconBlogs = blogsMaster['hvac-services'].blogArray

    const currencyCd = "SGD"
            
    let standardServicing = []
    let annualServicing = []
    let chemicalServicing = []
    let overhaulServicing = []    

    airconCostCalculation(currencyCd, annualServicing, standardServicing, chemicalServicing, overhaulServicing)
    
  return {
      props: {
        requestCategorySettings,
        modifiedDate,
        month,
        year,
        airconBlogs,
        standardServicing,
        annualServicing,
        chemicalServicing,
        overhaulServicing,
        currencyCd,
        countryName
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
      revalidate: 259200, // In seconds
  }
}
export default function Home(props) {
    const modifiedDate = props.modifiedDate
    const month = props.month
    const year = props.year
    const airconBlogs = props.airconBlogs
    const requestCategorySettings = props.requestCategorySettings;
    const standardServicing = props.standardServicing
    const annualServicing = props.annualServicing
    const chemicalServicing = props.chemicalServicing
    const overhaulServicing = props.overhaulServicing
    const currencyCd = props.currencyCd
    const brandName = "Panasonic";
    const requestType = 'Aircon Services'
    const countryName = props.countryName

    const [ requestForm, setRequestForm ] = useState(false)
    const [ isQuickBook, setIsQuickBook ] = useState(false)
    const [ isCustomBook, setIsCustomBook ] = useState(false)

    const [ isShowJobScope, setIsShowJobScope ] = useState(false)
    const [ serviceType, setServiceType ] = useState("general")
    const [ unit, setUnit ] = useState("")
    const [ unitType, setUnitType ] = useState("")
    const [ cost, setCost ] = useState("")

  return (
    <>
      <Head>
        <title>Panasonic Air Conditioner Servicing & Repair in Singapore</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description" content="StringsSG offers professional Panasonic aircon servicing in Singapore. Our experienced technicians provide comprehensive maintenance and repair services for Panasonic air conditioning units. Contact us for reliable and efficient servicing to ensure optimal performance of your aircon."/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"   content="https://www.stringssg.com/sg/aircon-servicing-singapore/panasonic" />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content={`Panasonic Air Conditioner Servicing & Repair in Singapore`}/>
        <meta property="og:description" content="StringsSG offers professional Panasonic aircon servicing in Singapore. Our experienced technicians provide comprehensive maintenance and repair services for Panasonic air conditioning units. Contact us for reliable and efficient servicing to ensure optimal performance of your aircon." />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-09T09:30:46+00:00" />
        <meta property="article:modified_time" content={modifiedDate} />
        <meta property="og:image"  content="https://stringssg-assets.s3.ap-southeast-1.amazonaws.com/static/blog/living/panasonic-air-conditioner.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3.ap-southeast-1.amazonaws.com/static/blog/living/panasonic-air-conditioner.png" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/sg/aircon-servicing-singapore/panasonic"/>
        <meta name="twitter:title" content={`Panasonic Air Conditioner Servicing & Repair in Singapore`}/> 
        <meta name="twitter:description" content="StringsSG offers professional Panasonic aircon servicing in Singapore. Our experienced technicians provide comprehensive maintenance and repair services for Panasonic air conditioning units. Contact us for reliable and efficient servicing to ensure optimal performance of your aircon."/>
        <link rel="icon" href="/favicon.ico" />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(buildAirconServiceGraph({
            path: '/sg/aircon-servicing-singapore/panasonic',
            pageName: 'Panasonic Air Conditioner Servicing & Repair in Singapore',
            description: 'StringsSG offers professional Panasonic aircon servicing in Singapore. Our experienced technicians provide comprehensive maintenance and repair services for Panasonic air conditioning units. Contact us for reliable and efficient servicing to ensure optimal performance of your aircon.',
            serviceName: 'Panasonic Aircon Servicing & Repair Singapore',
            serviceType: 'Aircon Servicing',
            image: 'https://stringssg-assets.s3.ap-southeast-1.amazonaws.com/static/blog/living/panasonic-air-conditioner.png',
            datePublished: '2025-01-09T09:30:46+00:00',
            modifiedDate,
            breadcrumbName: 'Panasonic',
          })) }}
        />
        <link rel="canonical" href="https://www.stringssg.com/sg/aircon-servicing-singapore/panasonic"/>
        </Head>
        <div>
            <RequestProvider>
                <AirconRequestSection
                    requestForm={requestForm}
                    setRequestForm={setRequestForm}
                    isQuickBook={isQuickBook}
                    setIsQuickBook={setIsQuickBook}
                    isCustomBook={isCustomBook}
                    setIsCustomBook={setIsCustomBook}
                    requestCategorySettings={requestCategorySettings}
                    standardServicing={standardServicing}
                    chemicalServicing={chemicalServicing}
                    overhaulServicing={overhaulServicing}
                    currencyCd={currencyCd}
                    countryName={countryName}
                    requestType={requestType}
                    setIsShowJobScope={setIsShowJobScope}
                    serviceType={serviceType}
                    setServiceType={setServiceType}
                    setUnit={setUnit}
                    setUnitType={setUnitType}
                    setCost={setCost}
                    heroImage="blog/living/panasonic-air-conditioner.png"
                    title="Panasonic Aircon Servicing Singapore"
                />
            </RequestProvider>
            <section className='max-w-5xl mx-auto py-10 px-2 grid md:grid-cols-2 gap-5 items-center'>
                 <header className='space-y-8 '>
                    <h1 className='text-3xl md:text-4xl font-semibold text-center'>Panasonic Aircon Servicing & Repair in Singapore</h1>
                    <p className='leading-8'>
                        StringsSG specializes in delivering professional Panasonic aircon servicing in Singapore. Our team of skilled technicians is dedicated to offering comprehensive 
                        maintenance and repair solutions for Panasonic air conditioning units. You can easily initiate a request for dependable and efficient servicing, guaranteeing the peak 
                        performance of your aircon system.
                    </p>  
                </header>
                <div className='relative flex justify-center max-w-md mx-auto'>
                    <Image className='rounded-lg'
                            src={s3Static + "blog/living/panasonic-tag.png"}
                            height={150}
                            width={300}
                            style={{objectFit: 'contain', height:"auto", width:"auto"}}
                            placeholder='blur'
                            blurDataURL={s3Static + "placeholder.png"}
                            alt='Panasonic Aircon Servicing '
                    />          
                </div>
            </section>
            <AirconPricing
                standardServicing={standardServicing} 
                annualServicing={annualServicing} 
                chemicalServicing={chemicalServicing} 
                overhaulServicing={overhaulServicing} 
                gasTopup={[{type: 'R22', priceRange: 'S$40 - S$100'}, {type: 'R410A', priceRange: 'S$90 - S$150'}, {type: 'R32', priceRange: 'S$120 - S$220'}]}  
                currencyCd={currencyCd}
            />
            <section className='py-5 bg-slate-600'>
                <div className='max-w-2xl mx-auto text-center text-white py-5 space-y-4 px-2'>   
                    <h2 className='text-2xl font-bold'>Panasonic Aircon Servicing Cost Calculator</h2>                
                    <p className='leading-7'>Use this calculator to get an estimation of how much you should be paying for Panasonic Aircon Servicing in Singapore.</p>                       
                </div>
                <AirconServiceCostCalculator requestCategorySettings={requestCategorySettings}/>
            </section>
            <section className='max-w-5xl mx-auto py-10'>
                <AirconGeneralServiceProcess />
            </section> 
            <ServiceWarranty brand={brandName} />            
            <section className='max-w-5xl mx-auto py-10 px-2 space-y-3'>    
                <h2 className='text-2xl md:text-3xl text-center'>
                    <strong>Latest Panasonic Aircon Models in Singapore</strong>
                </h2>
                <div className='space-y-5 leading-8'>   
                    <p>
                        StringsSG is dedicated to providing specialized servicing for a diverse range of Panasonic air conditioning models. Whether you possess a Panasonic Smile Series, 
                        Panasonic Multi-Split Series, or Panasonic Inverter Series, our team of skilled technicians is extensively trained to proficiently handle all varieties of Panasonic 
                        air conditioning systems.                  
                    </p> 
                    <div className='relative h-96 w-full'>
                        <Image className='rounded-lg'
                                src={s3Static + "blog/living/panasonic-air-conditioner.png"}
                                fill
                                sizes="(max-width: 768px) 100vw, 33vw"
                                style={{objectFit: 'contain'}}
                                placeholder='blur'
                                blurDataURL={s3Static + "placeholder.png"}
                                alt='Panasonic New Aircon'
                        />          
                    </div>
                </div> 
            </section>
            <section className='max-w-5xl mx-auto my-10 space-y-10'>
                <section className='grid md:grid-cols-2 gap-5'> 
                    <article className='border shadow p-4 rounded-lg hover:shadow-xl transition duration-300'>
                        <h3 className='font-bold text-lg md:text-2xl text-center'>Panasonic Deluxe Inverter (Aero Series)</h3>
                        <div className='relative h-96 w-full'>
                            <Image
                                src={s3Static + "blog/living/panasonic-deluxe-inverter.jpg"}
                                fill
                                sizes="(max-width: 768px) 100vw, 33vw"
                                style={{objectFit: 'cover'}}
                                placeholder='blur'
                                blurDataURL={s3Static + "placeholder.png"}
                                alt='Panasonic Deluxe Inverter (Aero Series)'
                            />
                        </div> 
                        <p className='text-sm leading-7'>
                            The Panasonic AERO Series boasts an elegant slim design characterized by smooth lines and graceful curves. Its glossy pearl finish and chrome escutcheon add a 
                            touch of opulence, creating a luxurious feel. You can choose between single-split or multi-split.
                        </p>
                    </article>
                    <article className='border shadow p-4 rounded-lg hover:shadow-xl transition duration-300'>
                        <h3 className='font-bold text-lg md:text-2xl text-center'>Panasonic Premium Inverter (XS Series)</h3>
                        <div className='relative h-96 w-full'>
                            <Image
                                src={s3Static + "blog/living/panasonic-premium-xs-series.png"}
                                fill
                                sizes="(max-width: 768px) 100vw, 33vw"
                                style={{objectFit: 'contain'}}
                                placeholder='blur'
                                blurDataURL={s3Static + "placeholder.png"}
                                alt='Panasonic Premium Inverter EZi Series (XS Series)'
                            />
                        </div> 
                        <p className='text-sm leading-7'>
                            The Panasonic XS Series 5-ticks Air Conditioner offers a delightful experience of cooler and cleaner air while maximizing energy efficiency. With the 
                            inclusion of nanoe-G technology, it effectively eliminates dust and harmful PM2.5 particles from the air, providing a healthier and purer environment 
                            for you and your loved ones. You can choose between single-split or multi-split.
                        </p>
                    </article>
                </section>
                <section className='text-center space-y-4'>
                    <h3 className='text-xl md:text-2xl font-bold uppercase text-amber-800'>New System Price Range</h3>
                    <p className='leading-8'>
                        If you&apos;re contemplating the acquisition of a new Panasonic air conditioning system, we provide competitive pricing options customized to your specific needs. 
                        The cost range for Panasonic AC systems may fluctuate based on variables such as the model, capacity, features, and installation intricacy. Feel free to get in touch 
                        with us for a personalized quotation that aligns with your requirements.
                    </p> 
                </section>
                <section className='text-center space-y-4'>
                    <h3 className='text-xl md:text-2xl font-bold uppercase text-amber-800'>Manufacturer Warranty Coverage</h3>
                    <p className='leading-8'>
                        Each brand-new Panasonic air conditioning system comes with a manufacturer&apos;s warranty, providing coverage for a designated period of time. The duration of the 
                        warranty may vary depending on the specific model and components of the system, typically ranging from 1 to 5 years. Our team is fully prepared to provide you 
                        with comprehensive information regarding the terms and conditions of the warranty that apply to your Panasonic AC system.
                       
                    </p>    
                </section>
            </section>
            <section className="py-10 px-4 max-w-5xl mx-auto space-y-6">
                <h2 className="font-bold text-center text-2xl md:text-3xl uppercase">
                    Common Panasonic Aircon Error Codes & Problems
                </h2>

                <article className="text-gray-700 text-base leading-relaxed space-y-4">
                    <p>
                    If your Panasonic air conditioner is not working as expected, it may be displaying an error code to help identify the issue. Below are some of the most frequently reported Panasonic aircon problems and the corresponding error codes.
                    </p>

                    <h3 className="text-lg font-semibold text-gray-800 pt-4">Common Panasonic Aircon Issues:</h3>
                    <ul className="list-disc pl-5 space-y-1">
                    <li>Poor cooling or insufficient airflow</li>
                    <li>Strange noises or vibrations</li>
                    <li>Water leakage</li>
                    <li>Sensor or control board malfunctions</li>
                    <li>Compressor or fan motor failures</li>
                    </ul>

                    <p>
                    Panasonic air conditioners display specific error codes on the control panel. These codes help technicians quickly identify faults. Here are the most common error codes and what they mean:
                    </p>

                    <h3 className="text-lg font-semibold text-gray-800 pt-4">Panasonic Aircon Error Code Table:</h3>
                    <div className="overflow-x-auto">
                    <table className="w-full border-collapse border border-slate-300 text-sm text-gray-700">
                        <thead className="bg-gray-100 text-orange-600">
                        <tr>
                            <th className="py-2 px-3 border border-slate-300 text-left">Error Code</th>
                            <th className="py-2 px-3 border border-slate-300 text-left">Problem & Solution</th>
                        </tr>
                        </thead>
                        <tbody>
                        {[
                            { code: 'H11', desc: 'Indoor/outdoor communication failure' },
                            { code: 'H12', desc: 'Communication circuit voltage too low' },
                            { code: 'H14', desc: 'Indoor intake temperature sensor failure' },
                            { code: 'H15', desc: 'Outdoor compressor temperature sensor failure' },
                            { code: 'H16', desc: 'Indoor suction temperature sensor failure' },
                            { code: 'H19', desc: 'Outdoor discharge temperature sensor failure' },
                            { code: 'F95', desc: 'Outdoor DC fan motor failure' },
                            { code: 'F96', desc: 'High-pressure control activated' },
                            { code: 'F97', desc: 'Low-pressure control activated' },
                            { code: 'F98', desc: 'Heat sink temperature sensor failure' },
                            { code: 'F99', desc: 'Refrigerant system failure' },
                        ].map(({ code, desc }) => (
                            <tr key={code} className="hover:bg-gray-50">
                            <td className="py-2 px-3 border border-slate-300 text-orange-600 font-semibold">{code}</td>
                            <td className="py-2 px-3 border border-slate-300">{desc}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    </div>

                    <p>
                    <strong>Note:</strong> Panasonic aircon error codes may vary depending on your unit’s model and series. If you encounter one of these codes, our licensed technicians can help diagnose and resolve the issue quickly and safely.
                    </p>
                </article>
            </section>
            <BlogsList blogs={airconBlogs}/>
        </div>
        {isShowJobScope &&
            <AnimatePresence>
                <AirconScope 
                setIsShowJobScope={setIsShowJobScope}
                serviceType={serviceType} 
                unit={unit} 
                unitType={unitType} 
                cost={cost} />
            </AnimatePresence>
        }
        <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
      />
      <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}
